import * as React from 'react';
import styled from 'styled-components';

import { Text, BREAK_POINTS, Colors } from '@origin-digital/style-guide';

import { SolarPanelIcon } from '../Icons/SolarPanelIcon';

const Container = styled.div`
  border: 1px solid ${Colors.GREY16};
  padding: 16px;
  margin-bottom: 32px;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: flex;
    flex-direction: row;
    padding: 32px;
    margin-bottom: 48px;
  }
`;

const Copy = styled.div`
  margin-bottom: 16px;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    margin-bottom: 0;
    margin-right: 32px;
  }
`;
export const RegulatorySignPostSA = () => {
  return (
    <Container>
      <Copy>
        <Text color="grey" size="sm">
          As a South Australian solar customer, there are new government regulations that apply to
          the installation of solar systems. This includes you being required to appoint a
          registered agent to manage your solar system. The registered agent will need to have the
          capability to remotely disconnect and reconnect your solar system when lawfully directed
          to do so due to a power network emergency, like extremely hot weather conditions.
          <br />
          <br />
          Great news. You can nominate Origin to act as your registered agent.
        </Text>
      </Copy>
      <div>
        <SolarPanelIcon size={96} />
      </div>
    </Container>
  );
};
